import { render } from "./Cropper.vue?vue&type=template&id=afe15592"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__